<template>
  <div>
    <el-dialog
      :title="selfDetail.formData.id ? '编辑出库单' : '新增出库单'"
      width="1200px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <e-form ref="refForm" :config="formConfig" :column="formColumn" :data.sync="selfDetail.formData" />
        <div class="flex flex-y-center m-t-10">
          <div class="group-title">物料明细</div>
          <el-link class="m-b-5 m-l-10" type="primary" size="mini" @click="chooseSource">
            <span>从销售订单选择</span>
            <span class="c-red">({{ selfDetail.list.length }})</span>
          </el-link>
          <el-link class="m-b-5 m-l-10" type="success" size="mini" @click="itemAdd"> 增行 </el-link>
        </div>
        <vxe-grid
          ref="refTable"
          :min-height="tableConfig.minHeight"
          :toolbar-config="tableConfig.toolbarConfig"
          :edit-config="tableConfig.editConfig"
          :row-config="tableConfig.rowConfig"
          :mouse-config="tableConfig.mouseConfig"
          :keyboard-config="tableConfig.keyboardConfig"
          :columns="tableColumn"
          :data="selfDetail.list"
          :show-footer="!!selfDetail.list.length"
          :max-height="this.$util.getViewHeight() - 460"
          :footer-method="tableFooterMethod"
        >
          <template #default_amount="{ row }">
            <span class="c-orange">{{ row.amount }}</span>
          </template>
          <template #default_operate="{ rowIndex }">
            <el-link title="清空" @click="itemClear(rowIndex)"> 清空 </el-link>
            <el-link title="删行" @click="itemDelete(rowIndex)"> 删行 </el-link>
          </template>

          <template #edit_material_name="{ row }">
            <el-input v-model="row.material_name" size="mini" clearable />
          </template>
          <template #edit_category="{ row }">
            <el-input v-model="row.category" size="mini" clearable />
          </template>
          <template #edit_spec="{ row }">
            <el-input v-model="row.spec" size="mini" clearable />
          </template>
          <template #edit_unit="{ row }">
            <el-input v-model="row.unit" size="mini" clearable />
          </template>
          <template #edit_qty="{ row }">
            <el-input v-model="row.qty" type="number" size="mini" clearable @blur="countsBlur(row)" />
          </template>
          <template #edit_weight="{ row }">
            <el-input v-model="row.weight" type="number" size="mini" clearable />
          </template>
          <template #edit_price="{ row }">
            <el-input v-model="row.price" type="number" size="mini" clearable @blur="countsBlur(row)" />
          </template>
          <template #edit_batch_no="{ row }">
            <el-input v-model="row.batch_no" size="mini" clearable />
          </template>
          <template #edit_remark="{ row }">
            <el-input v-model="row.remark" size="mini" clearable />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupPush">保存</el-button>
      </div>
    </el-dialog>
    <PopupChooseSource
      v-if="isShowPopupChooseSource"
      :show.sync="isShowPopupChooseSource"
      :list="selfDetail.list"
      @success="chooseSourceSuccess"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupChooseSource: () => import('./popup-choose-source')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      selfShow: false,
      warehouseList: [],
      locationList: [],
      selfDetail: {
        formData: {
          id: '',
          bill_no: '',
          bill_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'),
          warehouse_id: '',
          warehouse_name: '',
          location_id: '',
          location_name: '',
          customer_name: '',
          source_type: '手动出库',
          source_no: '',
          source_id: '',
          remark: ''
        },
        list: []
      },
      formConfig: {
        inline: true,
        width: '360px'
      },
      tableColumn: [
        { fixed: 'left', title: '序号', type: 'seq', width: 40 },
        { title: '物料名称', field: 'material_name', width: 140, slots: { edit: 'edit_material_name' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '材质', field: 'category', width: 90, slots: { edit: 'edit_category' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '规格(mm)', field: 'spec', width: 120, slots: { edit: 'edit_spec' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '单位', field: 'unit', width: 60, slots: { edit: 'edit_unit' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '数量', field: 'qty', width: 90, slots: { edit: 'edit_qty' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '重量', field: 'weight', width: 90, slots: { edit: 'edit_weight' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '单价(元)', field: 'price', width: 90, slots: { edit: 'edit_price' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '金额(元)', field: 'amount', width: 100, slots: { default: 'default_amount' } },
        { title: '批号', field: 'batch_no', width: 110, slots: { edit: 'edit_batch_no' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '备注', field: 'remark', width: 120, slots: { edit: 'edit_remark' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '操作', fixed: 'right', slots: { default: 'default_operate' }, width: 90 }
      ],
      isShowPopupChooseSource: false
    }
  },
  computed: {
    disabled() {
      let st = Number(this.selfDetail.formData.status)
      return st === 2 || st === 3
    },
    tableConfig() {
      let disabled = this.disabled
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    warehouseOptions() {
      return this.warehouseList.map((item) => ({ key: item.warehouse_name, val: item.id }))
    },
    locationOptions() {
      return this.locationList.map((item) => ({ key: item.location_code, val: item.id }))
    },
    formColumn() {
      return [
        { type: 'text', title: '出库单号', field: 'bill_no', placeholder: '自动生成', disabled: true },
        { type: 'date', title: '出库日期', field: 'bill_date', format: 'yyyy-MM-dd', valueFormat: 'yyyy-MM-dd' },
        {
          type: 'select',
          title: '仓库',
          field: 'warehouse_id',
          options: this.warehouseOptions,
          fnChange: () => this.onWarehouseChange()
        },
        {
          type: 'select',
          title: '库位',
          field: 'location_id',
          options: this.locationOptions,
          fnChange: () => this.onLocationChange()
        },
        { type: 'text', title: '客户', field: 'customer_name' },
        {
          type: 'select',
          title: '来源类型',
          field: 'source_type',
          options: [
            { key: '销售出库', val: '销售出库' },
            { key: '领料出库', val: '领料出库' },
            { key: '退货出库', val: '退货出库' },
            { key: '手动出库', val: '手动出库' }
          ]
        },
        { type: 'text', title: '来源单号', field: 'source_no' },
        { type: 'text', title: '备注', field: 'remark' }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getWarehouseList()
    if (this.id) {
      this.getDetailData()
    }
  },
  methods: {
    getWarehouseList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/newWarehouse/list',
        data: { currentPage: 1, pageSize: this.$constant.pageMax, sortData: { id: 'desc' } }
      })
        .then((res) => {
          if (res.status === 200) {
            this.warehouseList = (res.data.page && res.data.page.list) || []
          }
        })
        .catch(() => {})
    },
    getLocationList(warehouseId) {
      if (!warehouseId) {
        this.locationList = []
        return
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/warehouseLocation/list',
        data: { currentPage: 1, pageSize: this.$constant.pageMax, warehouseId, deleted: false, sortData: { id: 'desc' } }
      })
        .then((res) => {
          if (res.status === 200) {
            this.locationList = (res.data.page && res.data.page.list) || []
          }
        })
        .catch(() => {})
    },
    onWarehouseChange() {
      let wh = this.warehouseList.find((item) => item.id === this.selfDetail.formData.warehouse_id)
      this.selfDetail.formData.warehouse_name = wh ? wh.warehouse_name : ''
      this.selfDetail.formData.location_id = ''
      this.selfDetail.formData.location_name = ''
      this.getLocationList(this.selfDetail.formData.warehouse_id)
    },
    onLocationChange() {
      let lo = this.locationList.find((item) => item.id === this.selfDetail.formData.location_id)
      this.selfDetail.formData.location_name = lo ? lo.location_code : ''
    },
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/stockOut/detail',
        params: { id: this.id }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let fd = res.data.formData || {}
          let keys = ['bill_no', 'bill_date', 'warehouse_name', 'customer_name', 'source_type', 'source_no', 'remark']
          keys.forEach((k) => {
            if (fd[k] === null || fd[k] === undefined) fd[k] = ''
          })
          // bill_date 可能为 Date/时间戳，统一格式化为 yyyy-MM-dd 供日期选择器绑定
          if (fd.bill_date) {
            fd.bill_date =
              typeof fd.bill_date === 'string'
                ? fd.bill_date.substring(0, 10)
                : this.$XEUtils.toDateString(fd.bill_date, 'yyyy-MM-dd')
          }
          this.selfDetail.formData = fd
          this.getLocationList(fd.warehouse_id)
          this.selfDetail.list = (res.data.list || []).map((item) => {
            item.qty = item.qty === null || item.qty === undefined ? '' : item.qty
            item.price = item.price === null || item.price === undefined ? '' : item.price
            item.amount = item.amount === null || item.amount === undefined ? '' : item.amount
            item.weight = item.weight === null || item.weight === undefined ? '' : item.weight
            item.batch_no = item.batch_no || ''
            item.remark = item.remark || ''
            return item
          })
        }
      })
    },
    chooseSource() {
      this.isShowPopupChooseSource = true
    },
    chooseSourceSuccess(list) {
      let resultOld = this.$util.deepCopy(this.selfDetail.list)
      let resultNew = this.$util.deepCopy(list)
      let resultStart = []
      let resultEnd = []
      resultOld.forEach((itemSt) => {
        let isRepeat = resultNew.some((itemNd) => itemNd.source_item_id === itemSt.source_item_id)
        if (isRepeat) resultStart.push(itemSt)
      })
      resultNew.forEach((itemNd) => {
        let isRepeat = resultOld.some((itemSt) => itemSt.source_item_id === itemNd.source_item_id)
        if (!isRepeat) {
          // 映射销售订单明细 -> 出库明细
          let item = {
            material_name: itemNd.name || '',
            category: itemNd.category || '',
            spec: itemNd.spec || '',
            unit: itemNd.unit || '',
            qty: itemNd.counts || '',
            weight: itemNd.weight || '',
            price: itemNd.goods_price || '',
            amount: this.$XEUtils.multiply(Number(itemNd.goods_price) || 0, Number(itemNd.counts) || 0),
            batch_no: itemNd.batch_no || '',
            source_item_id: itemNd.source_item_id,
            remark: ''
          }
          resultEnd.push(item)
          if (!this.selfDetail.formData.source_no && itemNd.bill_code) {
            this.selfDetail.formData.source_no = itemNd.bill_code
            this.selfDetail.formData.source_id = itemNd.source_bill_id || ''
            this.selfDetail.formData.source_type = '销售出库'
            if (itemNd.company_name) this.selfDetail.formData.customer_name = itemNd.company_name
          }
        }
      })
      this.selfDetail.list = [...resultStart, ...resultEnd]
    },
    itemAdd() {
      this.selfDetail.list.push({
        material_name: '',
        category: '',
        spec: '',
        unit: '',
        qty: '',
        weight: '',
        price: '',
        amount: '',
        batch_no: '',
        source_item_id: '',
        remark: ''
      })
    },
    countsBlur(row) {
      row.amount = this.$XEUtils.multiply(Number(row.price) || 0, Number(row.qty) || 0)
    },
    itemClear(index) {
      let row = this.selfDetail.list[index]
      if (!row) return
      row.material_name = ''
      row.category = ''
      row.spec = ''
      row.unit = ''
      row.qty = ''
      row.weight = ''
      row.price = ''
      row.amount = ''
      row.batch_no = ''
      row.remark = ''
    },
    itemDelete(index) {
      this.selfDetail.list.splice(index, 1)
    },
    tableFooterMethod({ columns, data }) {
      data.forEach((item) => {
        item.amount = this.$XEUtils.multiply(Number(item.price) || 0, Number(item.qty) || 0)
      })
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['qty', 'weight', 'amount'].includes(column.field)) {
            return this.$tool.listAddTotal(data, column.field)
          }
        })
      ]
    },
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    popupPush() {
      if (!this.selfDetail.formData.warehouse_id) {
        this.$message.warning('请选择仓库')
        return
      }
      let data = this.$util.deepCopy(this.selfDetail)
      data.list.forEach((item) => {
        item.warehouse_id = data.formData.warehouse_id
        item.warehouse_name = data.formData.warehouse_name
        item.location_id = data.formData.location_id
        item.location_name = data.formData.location_name
      })
      this.$api({
        method: 'post',
        url: '/admin/gcvip/stockOut/saveOrUpdate',
        data
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.popupCancel()
            this.$emit('success')
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.data.msg || '保存失败')
          }
        })
        .catch((error) => {
          this.$message.error(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .group-title {
    font-size: 13px;
    font-weight: bold;
    color: @colorBlack;
  }
}
</style>
